hrd.fn = {
	actionURI: function(action){
		return hrd.globals.contextRoot + '/' + action + '.do';
	},
	logEvent: function(evt){
		var verbose = false;
		if(verbose){
			if(evt.target && evt.target.id){
				console.log('Executing event: ' + evt.type + ' on target ' + evt.target.id);
			} else {
				console.log('Executing event: ' + evt.type);
			}
		}
	},
	remoteLogging: function(message){
		var sProvider = 'com.hrd.system.actions.accessories.ConsoleLoggerJsonProvider';
		var sMethod = 'debug';
		if(dashboardInstance){
			return dashboardInstance.invokeProvider(sProvider, sMethod, {message: message});
		} else {
			return $.ajax({
				url : hrd.globals.jsondataURI,
				dataType : "json",
				data:  {
					method: sMethod,
					impl : sProvider,
					message: message
				}
			});
		}
	}
};